"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicencePriceUpdateModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var DrivingLicencePriceUpdateModalWidget = /** @class */ (function (_super) {
    __extends(DrivingLicencePriceUpdateModalWidget, _super);
    function DrivingLicencePriceUpdateModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.hideModal = function () {
            _this.setState({
                show: false
            });
        };
        _this.state = {
            show: true
        };
        return _this;
    }
    DrivingLicencePriceUpdateModalWidget.prototype.render = function () {
        var interaction = this.props.interaction;
        var isAnnual = interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL;
        var premiumTypeWording = isAnnual ? "year" : "month";
        var premium = isAnnual ? interaction.factors.annualPremium : interaction.factors.monthlyPremium;
        var previousPremium = isAnnual ? interaction.uistate.temporaryAnnualPremium : interaction.uistate.temporaryMonthlyPremium;
        var premiumChangeLabel = premium > previousPremium ? "increased" : "decreased";
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "notification-warning-modal", isOpen: this.state.show, toggle: this.hideModal, children: [(0, jsx_runtime_1.jsxs)(reactstrap_1.ModalHeader, { toggle: this.hideModal, children: [(0, jsx_runtime_1.jsx)("img", { className: "info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon" }), (0, jsx_runtime_1.jsxs)("div", { className: "text-blue-2", children: ["Price ", (0, jsx_runtime_1.jsx)("span", { className: "text-highlight", children: "update" })] })] }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "modal-text", children: (0, jsx_runtime_1.jsxs)("p", { children: ["Just so you know, your new price has ", premiumChangeLabel, " to ", (0, jsx_runtime_1.jsxs)("span", { children: [(0, commonFunctions_1.getAmountToDisplay)(premium), " / ", premiumTypeWording] }), " due to the information on your driving licence that wasn't previously disclosed."] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next", onClick: this.hideModal, children: "Ok, I understand" }) })] }));
    };
    DrivingLicencePriceUpdateModalWidget.prototype.renderInputField = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    return DrivingLicencePriceUpdateModalWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.DrivingLicencePriceUpdateModalWidget = DrivingLicencePriceUpdateModalWidget;
//# sourceMappingURL=DrivingLicencePriceUpdateModalWidget.js.map